import useSettings from "../hooks/useSettings";
import React from "react";
import Countdown from "../components/Countdown";

function parseDeadline(dateStr, timeStr) {
  if (!dateStr) return null;
  const m = String(timeStr || "11:59 PM").match(/(\d+):(\d+)\s*(AM|PM)/i);
  let h = 23, mn = 59;
  if (m) {
    h = parseInt(m[1], 10);
    mn = parseInt(m[2], 10);
    if (m[3].toUpperCase() === "PM" && h !== 12) h += 12;
    if (m[3].toUpperCase() === "AM" && h === 12) h = 0;
  }
  const d = new Date(dateStr + "T00:00:00");
  d.setHours(h, mn, 0, 0);
  return d;
}

export default function StudentDashboard({ form, completionPct, setActiveSection, isSectionDone }) {
  const { settings } = useSettings();
  const deadlineTarget = parseDeadline(settings.submissionDeadline, settings.submissionDeadlineTime);
  const sections = [
    { id: "profile", label: "Profile Info", icon: "👤", partialFields: ["firstName", "lastName", "undergradDegree", "hometown", "classYear"] },
    { id: "academic", label: "Academic & Background", icon: "🎓", partialFields: ["continueTrip"] },
    { id: "internships", label: "Internships", icon: "💼", partialFields: ["springInternshipCompany", "summerInternshipCompany", "investmentDecision"] },
    { id: "statement", label: "Personal Statement", icon: "📝", partialFields: ["personalStatement"] },
    { id: "interests", label: "Role Interests", icon: "📊", partialFields: ["naturalGas", "crudeOil", "power", "renewables", "fundamentalAnalyst"] },
    { id: "documents", label: "Documents", icon: "📎", partialFields: ["resumeURL"] },
  ];

  const getSectionStatus = (section) => {
    if (isSectionDone && isSectionDone(section.id)) return "complete";
    const hasPartial = section.partialFields.some(f => {
      const v = form[f];
      return v !== undefined && v !== "" && v !== null;
    });
    return hasPartial ? "partial" : "empty";
  };

  return (
    <div>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: "#1a1a2e", marginBottom: 6 }}>
          {form.firstName ? `Hey, ${form.firstName} ` : "Welcome to TRIP"}
        </h1>
        <p style={{ color: "#888", fontSize: 15 }}>Complete your profile before the {new Date((settings.submissionDeadline || "2025-07-06") + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric" })} deadline.</p>
      </div>

      {/* Progress banner */}
      <div style={{ background: `linear-gradient(135deg, #2d0000, #6f0000)`, borderRadius: 16, padding: "28px 32px", marginBottom: 28, color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 6, letterSpacing: 1, textTransform: "uppercase" }}>Profile Completion</div>
          <div style={{ fontSize: 42, fontWeight: 900, letterSpacing: -2 }}>{completionPct}<span style={{ fontSize: 20, opacity: 0.7 }}>%</span></div>
          <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: 4, height: 6, width: 200, marginTop: 12 }}>
            <div style={{ background: "white", height: 6, borderRadius: 4, width: completionPct + "%", transition: "width 0.5s" }} />
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 13, opacity: 0.6, marginBottom: 4 }}>Deadline</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>{new Date((settings.submissionDeadline || "2025-07-06") + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</div>
          <div style={{ fontSize: 13, opacity: 0.6, marginBottom: 10 }}>{settings.submissionDeadlineTime || "11:59 PM"}</div>
          <Countdown target={deadlineTarget} doneLabel="Deadline passed" />
        </div>
      </div>

      {/* Section cards */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
        {sections.map(section => {
          const status = getSectionStatus(section);
          return (
            <div key={section.id} onClick={() => setActiveSection(section.id)}
              style={{ background: "white", borderRadius: 12, padding: "22px 24px", cursor: "pointer", border: `1.5px solid ${status === "complete" ? "#86efac" : status === "partial" ? "#ffe082" : "#f0f0f0"}`, transition: "all 0.2s", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}
              onMouseOver={e => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.08)"; }}
              onMouseOut={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.05)"; }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                <span style={{ fontSize: 28 }}>{section.icon}</span>
                <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: status === "complete" ? "#f0fff4" : status === "partial" ? "#fff8e1" : "#f5f5f5", color: status === "complete" ? "#166534" : status === "partial" ? "#92400e" : "#aaa" }}>
                  {status === "complete" ? "✓ Done" : status === "partial" ? "In Progress" : "Not Started"}
                </span>
              </div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#1a1a2e", marginBottom: 4 }}>{section.label}</div>
              <div style={{ fontSize: 12, color: "#aaa" }}>Click to edit →</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
